import { NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import Header from 'src/common/components/Header';
import Layout from 'src/common/components/Layout';
import DescriptionMetaTag from 'src/common/components/MetaTags/DescriptionMetaTag';
import handleApiErrors from 'src/common/utils/handleApiErrors';
import serverGetUser from 'src/common/utils/serverGetUser';
import withCommonMiddleware from 'src/common/utils/withCommonMiddleware';
import MobileAppsRoot from 'src/MobileApps/components/Root';
import ReviewAndAppLinks from 'src/common/components/ReviewAndAppLinks';
import SubFooter from 'src/common/components/SubFooter';
import FooterLinks from 'src/common/components/FooterLinks';
import Footer from 'src/common/components/Footer';
import SearchInputProvider from 'src/common/components/Search/SearchInputProvider';
import { loadTranslations } from 'src/common/utils/serverSidePropsHelpers';

type MobileAppsPageProps = {};

const MobileAppsPage: NextPage<MobileAppsPageProps> = () => {
  const [t] = useTranslation('mobile-apps-page');

  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <DescriptionMetaTag
        content={t('meta-description')}
      />
      <Layout overscrollColor="ivory">
        <SearchInputProvider>
          <Header
            variant="ivory"
            showBottomBorderOnScroll
            withSearch
          />
          <MobileAppsRoot />
          <Footer>
            <FooterLinks />
            <ReviewAndAppLinks />
            <SubFooter />
          </Footer>
        </SearchInputProvider>
      </Layout>
    </>
  );
};

export const getServerSideProps = (
  handleApiErrors(
    withCommonMiddleware<MobileAppsPageProps>(
      async (context) => {
        const userPromise = serverGetUser(context);
        const translationPromise = loadTranslations(
          context.locale,
          [
            'common',
            'mobile-apps-page',
            'navbar',
            'destination-navigation',
            'search-and-filters',
            'boat-categories',
            'footer',
          ],
        );

        return {
          props: {
            user: await userPromise,
            ...await translationPromise,
          },
        };
      },
    ),
  )
);

export default MobileAppsPage;
